import SkyNetObjectProfile from 'app/shared-components/SkyNetObjectProfile'
import domainConfig from './ARateCards.config'

const ARateCardsPage = () => {
    return (
        <SkyNetObjectProfile
            config={domainConfig}
        />
    )
}

export default ARateCardsPage
